module.exports = __webpack_public_path__ + "img/pic_hhyw_img.9579ae70.png";